export default __webpack_public_path__ + "static/media/ic-fee.9b02d4c7.svg";